module.exports = __webpack_public_path__ + "img/05.1c13af7d.jpg";